<mat-card class="estimate-review-multi-visit card-table" data-balance-summary-panel>
  <mat-card-title *ngIf="!embedded" class="estimate-review-multi-visit__title">
    <span class="estimate-review-multi-visit__title-label">
      <span class="estimate-review-multi-visit__heading text-primary uppercase text-sm">
        {{ 'balance.review.title' | translate }}
      </span>
      <mmx-balance-status-chip
        *ngIf="vm.workflowStatus as status"
        [status]="status"
      ></mmx-balance-status-chip>
    </span>

    <div class="estimate-review-multi-visit__title-actions">
      <button
        *ngIf="!hideFinalize"
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="finalizeDisabled"
        [matTooltip]="tooltipKey | translate"
        [matTooltipDisabled]="!isStatusBlocked"
        (click)="onFinalize()"
        data-balance-summary-finalize
      >
        {{ 'balance.review.finalize-all' | translate }}
      </button>

      <mmx-balance-actions-toolbar
        *ngIf="!hideActions"
        [capabilities]="summaryCapabilities"
        [data]="summaryData"
        [busy]="busy"
        [needsPricing]="needsPricing"
        (save)="save.emit()"
        (revert)="revert.emit()"
        (delete)="delete.emit()"
        (send)="send.emit($event)"
        (sendDocument)="sendDocument.emit()"
        (viewHistory)="viewHistory.emit()"
        (printLetter)="printLetter.emit($event)"
      ></mmx-balance-actions-toolbar>
    </div>
  </mat-card-title>

  <mat-card-content class="p-0">
    <ng-container *ngIf="vm.isEmpty; else rowsTemplate">
      <p class="estimate-review-multi-visit__empty my-4 text-center" data-balance-summary-empty>
        {{ 'balance.review.empty-state' | translate }}
      </p>
    </ng-container>
    <ng-template #rowsTemplate>
      <div class="estimate-review-multi-visit__column-head" role="row">
        <span></span>
        <span class="estimate-review-multi-visit__col-label text-primary uppercase text-sm">
          {{ 'balance.review.column.patient-responsibility' | translate }}
        </span>
        <span class="estimate-review-multi-visit__col-label text-primary uppercase text-sm">
          {{ 'balance.review.column.insurance-responsibility' | translate }}
        </span>
        <span class="estimate-review-multi-visit__col-label text-primary uppercase text-sm">
          {{ 'balance.review.column.total' | translate }}
        </span>
      </div>
      <div class="estimate-review-multi-visit__rows">
        <mmx-balance-visit-row
          *ngFor="let row of vm.rows; trackBy: trackByRow"
          [row]="row"
          [diff]="row.diff"
          [renumberedFrom]="row.renumberedFrom"
          (pbTrace)="pbTrace.emit($event)"
          (hbTrace)="hbTrace.emit($event)"
          (chargeBreakdown)="chargeBreakdown.emit($event)"
        ></mmx-balance-visit-row>
      </div>
    </ng-template>

    <ul *ngIf="diff && diff.removed.length > 0" class="removed-list" data-testid="removed-list">
      <li *ngFor="let r of diff.removed; trackBy: trackByRemoved">
        {{ 'balance.modify-session.diff.removed-label' | translate: { number: r.visitNumber } }}
      </li>
    </ul>
  </mat-card-content>

  <mmx-balance-grand-total-bar [totals]="vm.totals"></mmx-balance-grand-total-bar>
</mat-card>
